import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { API_BASE } from '../../config/apiBase';
const API = `${API_BASE}/manager/website`;

export default function RoomEditModal({ room, roomTypes, onClose, onSaved }) {
  const { token } = useAuth();
  const [roomNumber, setRoomNumber] = useState(room.room_number);
  const [roomTypeId, setRoomTypeId] = useState(room.room_type_id);
  const [status, setStatus] = useState(room.status);

  const save = async () => {
    await axios.put(`${API}/rooms/${room.id}`, {
      room_number: roomNumber,
      room_type_id: roomTypeId,
      status
    }, { headers: { Authorization: `Bearer ${token}` }});
    onSaved();
    onClose();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.18)',
      zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 18,
        boxShadow: '0 8px 32px rgba(18,48,73,0.18)',
        padding: '36px 32px 28px 32px',
        minWidth: 340,
        maxWidth: 400,
        width: '100%',
        position: 'relative',
        fontFamily: 'Segoe UI, Arial, sans-serif',
      }}>
        <h2 style={{
          margin: 0,
          marginBottom: 18,
          color: '#123049',
          fontWeight: 800,
          fontSize: '1.5rem',
          letterSpacing: '0.04em',
          textAlign: 'center',
        }}>Edit Room</h2>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontWeight: 600, color: '#4a5568', display: 'block', marginBottom: 4 }}>Room Number</label>
          <input value={roomNumber} onChange={e => setRoomNumber(e.target.value)} style={{ width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid #cbd5e0', fontSize: 16 }} />
        </div>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontWeight: 600, color: '#4a5568', display: 'block', marginBottom: 4 }}>Room Type</label>
          <select value={roomTypeId} onChange={e => setRoomTypeId(Number(e.target.value))} style={{ width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid #cbd5e0', fontSize: 16 }}>
            {roomTypes.map(rt => (
              <option key={rt.id} value={rt.id}>{rt.room_type}</option>
            ))}
          </select>
        </div>
        <div style={{ marginBottom: 24 }}>
          <label style={{ fontWeight: 600, color: '#4a5568', display: 'block', marginBottom: 4 }}>Status</label>
          <select value={status} onChange={e => setStatus(e.target.value)} style={{ width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid #cbd5e0', fontSize: 16 }}>
            <option value="available">Available</option>
            <option value="occupied">Occupied</option>
            <option value="maintenance">Maintenance</option>
          </select>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <button onClick={onClose} style={{
            background: '#e2e8f0', color: '#2d3748', border: 'none', borderRadius: 7, padding: '8px 18px', fontWeight: 600, fontSize: 15, cursor: 'pointer',
          }}>Cancel</button>
          <button onClick={save} style={{
            background: '#123049', color: '#fff', border: 'none', borderRadius: 7, padding: '8px 18px', fontWeight: 700, fontSize: 15, cursor: 'pointer',
          }}>Save</button>
        </div>
      </div>
    </div>
  );
}
